export const carouselSectionConfig = {
    name: 'CarouselSection',
    category: 'Zapier Sections',
    canHaveChildren: true,
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/70bef4e8e2b54f2a55972f5c147e48c6.png',
    inputs: [
        {
            name: 'heading',
            type: 'string',
            defaultValue: 'Section Heading',
        },
        {
            name: 'subheading',
            type: 'string',
            defaultValue: 'Section Subheading',
        },
    ],
    defaultChildren: Array(3).fill({
        '@type': '@builder.io/sdk:Element',
        component: {
            name: 'Block',
            options: {
                heading: 'Example heading',
                description: '<p>Example content...</p>',
                imageUrl: 'https://res.cloudinary.com/zapier-media/image/upload/q_auto/f_auto/v1656512382/Blog/Generic/abstract-zaps_qpodgh.png',
            },
        },
    }),
};
//# sourceMappingURL=config.js.map